import { Box, Divider, Skeleton, Stack } from '@mui/material'

export default function SkeletonPOCard() {
  return (
    <Box
      sx={{
        borderRadius: 2,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        boxShadow: 4,
      }}
    >
      {/* Card header skeleton mimicking the green PO header */}
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{
          bgcolor: 'action.disabledBackground',
          px: 3,
          py: 1.5,
          borderRadius: '8px 8px 0 0',
        }}
      >
        <Skeleton
          variant="circular"
          width={20}
          height={20}
          sx={{ bgcolor: 'action.disabled' }}
        />
        <Skeleton
          variant="text"
          width={120}
          sx={{ fontSize: '1rem', bgcolor: 'action.disabled' }}
        />
        <Box sx={{ flex: 1 }} />
        <Skeleton
          variant="text"
          width={60}
          sx={{ fontSize: '0.875rem', bgcolor: 'action.disabled' }}
        />
      </Stack>

      {/* Card body */}
      <Box sx={{ p: 2.5, position: 'relative', overflow: 'hidden' }}>
        {/* Header fields row */}
        <Stack
          direction="row"
          spacing={3}
          sx={{ mb: 2 }}
          useFlexGap
          flexWrap="wrap"
        >
          <Box>
            <Skeleton variant="text" width={50} sx={{ fontSize: '0.7rem' }} />
            <Skeleton variant="text" width={100} sx={{ fontSize: '0.9rem' }} />
          </Box>
          <Box>
            <Skeleton variant="text" width={55} sx={{ fontSize: '0.7rem' }} />
            <Skeleton variant="text" width={80} sx={{ fontSize: '0.9rem' }} />
          </Box>
          <Skeleton
            variant="rounded"
            width={50}
            height={22}
            sx={{ alignSelf: 'center' }}
          />
        </Stack>

        <Divider />

        {/* Line items table skeleton */}
        {[1, 2, 3].map((row) => (
          <Stack
            key={row}
            direction="row"
            spacing={2}
            sx={{ py: 1.2, borderBottom: 1, borderColor: 'divider' }}
          >
            <Skeleton variant="text" width="45%" sx={{ fontSize: '0.85rem' }} />
            <Skeleton variant="text" width="12%" sx={{ fontSize: '0.85rem' }} />
            <Skeleton variant="text" width="15%" sx={{ fontSize: '0.85rem' }} />
            <Skeleton variant="text" width="15%" sx={{ fontSize: '0.85rem' }} />
          </Stack>
        ))}

        {/* Total row */}
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={3}
          sx={{ mt: 1.5 }}
        >
          <Box>
            <Skeleton variant="text" width={40} sx={{ fontSize: '0.7rem' }} />
            <Skeleton variant="text" width={70} sx={{ fontSize: '0.9rem' }} />
          </Box>
        </Stack>
      </Box>
    </Box>
  )
}
